import { render, staticRenderFns } from "./ItsStockPackMaterialLoss.vue?vue&type=template&id=9522013a&scoped=true&"
import script from "./ItsStockPackMaterialLoss.vue?vue&type=script&lang=js&"
export * from "./ItsStockPackMaterialLoss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9522013a",
  null
  
)

export default component.exports